import React, { useState , useEffect } from 'react';
import ReactGA from 'react-ga4';
import styles from './review.module.scss';
import { Container, Row, Col } from 'react-bootstrap';
import { CustomButton } from '../../../../../shared/customButton';
import { addCVFilterStep, addCVReviewStep, addExternalAssessmentStep, addQuizStep, addReferenceCheckStep, addCustomEvaluationStep, addOneWayInterviewStep } from '../../../../../../services/util/hiringpipeline/steps';
import { addInterviewStep } from '../../../../../../services/util/hiringpipeline/steps';
import StarRating from '../../../../../shared/rate';

const Review = (props) => {

    const [state, setState] = useState(false);



    const submitDetails = async () => {
        setState(true);
        let respond ;
        if (props.values.stageType === 10) {

            respond = await addCVFilterStep(props.values.pipeline, props.values.stageName, props.values.keywordCount, props.values.keywords);
            
        } if (props.values.stageType === 20) {

            let userIDArray = [];
            props.values.reviewers.forEach(element => {
                userIDArray.push(element._id)
            });
            respond = await addCVReviewStep(userIDArray, props.values.pipeline, props.values.stageName, props.values.description, props.values.numReviewer, props.values.score, props.pipelineValues.reviewCriteria);
        } if (props.values.stageType === 30) {
            respond = await addInterviewStep(props.values.pipeline, props.values.stageName, props.values.description, props.values.score, props.values.interview_guidelines_to_candidate, props.pipelineValues.reviewCriteria);
        } if (props.values.stageType === 40) {

            let userIDArray = [];
            userIDArray.push(props.values.assessment_reviewers._id)

            respond = await addExternalAssessmentStep(props.values.pipeline, props.values.stageName, props.values.description, userIDArray, props.values.score, props.values.assessment_body, props.values.assessment_exp_date, props.pipelineValues.reviewCriteria);
        } if (props.values.stageType === 50) {
            respond = await addQuizStep(props.values.pipeline, props.values.stageName, props.values.score, props.values.quiz_template.quiz_template_id, props.values.quiz_exp_date);
        } if (props.values.stageType === 60) {

            let userIDArray = [];
            userIDArray.push(props.values.reference_check_reviewers._id)

            let respond = await addReferenceCheckStep(props.values.pipeline, props.values.stageName, props.values.min_no_of_references_required, props.values.description, props.values.guide_for_candidates, props.values.is_auto_request_referee_details_from_candidate_enabled, userIDArray);
            if (respond.success === true) {
                setState(false)
                props.getPipelineValues();
                props.handleClose();
            }
            else {
                setState(false)
            }
        } if (props.values.stageType === 70) {

            let userIDArray = [];
            userIDArray.push(props.values.custom_evaluation_reviewers._id)

            respond = await addCustomEvaluationStep(props.values.pipeline, props.values.stageName, props.values.description, userIDArray, props.values.score, props.values.custom_evaluation_description,props.pipelineValues.reviewCriteria);
        }
        if (props.values.stageType === 80) {

            let userIDArray = [];
            userIDArray.push(props.values.one_way_interview_reviewers._id)

            respond = await addOneWayInterviewStep(props.values.pipeline, props.values.stageName, props.values.description, userIDArray, props.values.score, props.values.interview_exp_in, props.values.one_way_interview_template.one_way_interview_template_id, props.pipelineValues.reviewCriteria);
        }


        if (respond.success === true) {

            ReactGA.event('eval_step_added_to_pipeline');
            setState(false)
            props.getPipelineValues();
            props.handleClose();
        }
        else {
            setState(false)
        } 
    }

    useEffect(() => {
        ReactGA.initialize(`${process.env.REACT_APP_CUSTOMER_FLOW_GOOGLE_ANALYTICS_ID}`);
    }, [])

    return (
        <div>
            <Container>
                <Row className={styles.pipelineDetailsRow}>
                    <Col xs={12} className="mt-1 mb-1">
                        <span className={styles.rowSubTitle}>Stage&nbsp;Name&nbsp;:</span>&nbsp;<span className={styles.rowValues} id="adminPanel_hiringPipeline_editPipeline_addStagesModal_review_stageNameReviewPageId">{props.values.stageName}</span>
                    </Col>
                </Row>

                <Row className={styles.pipelineDetailsRow}>
                    <Col xs={12} className="mt-1 mb-1">
                        <span className={styles.rowSubTitle}>Stage&nbsp;Type&nbsp;:</span>&nbsp;<span className={styles.rowValues} id="adminPanel_hiringPipeline_editPipeline_addStagesModal_review_stageTypeReviewPageId">{props.values.stageType === 10 ? 'Auto CV Filter' : props.values.stageType === 20 ? 'CV Review' : props.values.stageType === 30 ? 'Interview' : props.values.stageType === 40 ? 'External Assignment' : props.values.stageType === 50 ? 'Quiz' : props.values.stageType === 60 ? 'Reference Check' : props.values.stageType === 70 ? 'Custom Evaluation' : props.values.stageType === 80 ? 'One Way Interview' : ''}</span>
                    </Col>
                </Row>

                {
                    (props.values.stageType === 20) &&

                    <Row className={styles.pipelineDetailsRow}>
                        <Col xs={12} className="mt-1 mb-1">
                            <span className={styles.rowSubTitle}>Reviewers&nbsp;:</span><br />
                            <span className={styles.rowValues}>
                                {props.values.reviewers.map((value, index) => (
                                    <p className="mb-1" key={index} id={`adminPanel_hiringPipeline_editPipeline_addStagesModal_review_reviewersId.${index}`}><i className="fas fa-circle"></i>&nbsp;{value.user_id.email}&nbsp;-&nbsp;{value.user_id.first_name + ' ' + value.user_id.last_name}</p>
                                ))
                                }
                            </span>
                        </Col>
                    </Row>
                }

                {
                    (props.values.stageType === 40) &&

                    <Row className={styles.pipelineDetailsRow}>
                        <Col xs={12} className="mt-1 mb-1">
                            <span className={styles.rowSubTitle}>Reviewers&nbsp;:</span><br />
                            <span className={styles.rowValues}>

                                    <p className="mb-1" id="adminPanel_hiringPipeline_editPipeline_addStagesModal_review_reviewerId"><i className="fas fa-circle"></i>&nbsp;{props.values.assessment_reviewers.user_id.email}&nbsp;-&nbsp;{props.values.assessment_reviewers.user_id.first_name + ' ' + props.values.assessment_reviewers.user_id.last_name}</p>

                            </span>
                        </Col>
                    </Row>
                }

                {
                    (props.values.stageType === 60) &&
                    <div>
                        <Row className={styles.pipelineDetailsRow}>
                            <Col xs={12} className="mt-1 mb-1">
                                <span className={styles.rowSubTitle}>Reviewers&nbsp;:</span><br />
                                <span className={styles.rowValues}>

                                        <p className="mb-1" id="adminPanel_hiringPipeline_editPipeline_addStagesModal_review_reviewersId"><i className="fas fa-circle"></i>&nbsp;{props.values.reference_check_reviewers.user_id.email}&nbsp;-&nbsp;{props.values.reference_check_reviewers.user_id.first_name + ' ' + props.values.reference_check_reviewers.user_id.last_name}</p>

                                </span>
                            </Col>
                        </Row>
                        <Row className={styles.pipelineDetailsRow}>
                            <Col xs={12} className="mt-1 mb-1">
                                <span className={styles.rowSubTitle}>Minimum Number of References&nbsp;:</span>&nbsp;<span className={styles.rowValues}>{props.values.min_no_of_references_required}</span>
                            </Col>
                        </Row>
                        <Row className={styles.pipelineDetailsRow}>
                            <Col xs={12} className="mt-1 mb-1">
                                <span className={styles.rowSubTitle}>Request referee details automatically&nbsp;:</span>&nbsp;<span className={styles.rowValues}>{props.values.is_auto_request_referee_details_from_candidate_enabled? 'Active': 'Inactive'}</span>
                            </Col>
                        </Row>
                    </div>
                }
                {
                    (props.values.stageType === 70) &&

                    <Row className={styles.pipelineDetailsRow}>
                        <Col xs={12} className="mt-1 mb-1">
                            <span className={styles.rowSubTitle}>Reviewers&nbsp;:</span><br />
                            <span className={styles.rowValues}>

                                    <p className="mb-1" id="adminPanel_hiringPipeline_editPipeline_addStagesModal_review_reviewersId"><i className="fas fa-circle"></i>&nbsp;{props.values.custom_evaluation_reviewers.user_id.email}&nbsp;-&nbsp;{props.values.custom_evaluation_reviewers.user_id.first_name + ' ' + props.values.custom_evaluation_reviewers.user_id.last_name}</p>

                            </span>
                        </Col>
                    </Row>
                }

                {
                    (props.values.stageType === 80) &&

                    <Row className={styles.pipelineDetailsRow}>
                        <Col xs={12} className="mt-1 mb-1">
                            <span className={styles.rowSubTitle}>Interview&nbsp;Template&nbsp;:</span>&nbsp;<span className={styles.rowValues}>{props.values.one_way_interview_template.template_name}</span>
                        </Col>
                    </Row>
                }

                {
                    (props.values.stageType === 80) &&

                    <Row className={styles.pipelineDetailsRow}>
                        <Col xs={12} className="mt-1 mb-1">
                            <span className={styles.rowSubTitle}>Reviewers&nbsp;:</span><br />
                            <span className={styles.rowValues}>

                                <p className="mb-1" ><i className="fas fa-circle"></i>&nbsp;{props.values.one_way_interview_reviewers.user_id.email}&nbsp;-&nbsp;{props.values.one_way_interview_reviewers.user_id.first_name + ' ' + props.values.one_way_interview_reviewers.user_id.last_name}</p>

                            </span>
                        </Col>
                    </Row>
                }

                {props.values.stageType === 20 &&
                    <Row className={styles.pipelineDetailsRow}>
                        <Col xs={12} className="mt-1 mb-1">
                            <span className={styles.rowSubTitle}>No&nbsp;Of&nbsp;Reviewers&nbsp;Per&nbsp;CV&nbsp;:</span>&nbsp;<span className={styles.rowValues} id="adminPanel_hiringPipeline_editPipeline_addStagesModal_review_noOfReviewersPerCvId">{props.values.numReviewer}</span>
                        </Col>
                    </Row>
                }
                {
                    (props.values.stageType === 50) &&

                    <Row className={styles.pipelineDetailsRow}>
                        <Col xs={12} className="mt-1 mb-1">
                                <span className={styles.rowSubTitle}>Quiz&nbsp;Template&nbsp;:</span>&nbsp;<span className={styles.rowValues} id="adminPanel_hiringPipeline_editPipeline_addStagesModal_review_quizTemplateId">{props.values.quiz_template.name}</span>
                        </Col>
                    </Row>
                }
                {(props.values.stageType === 20 || props.values.stageType === 30 || props.values.stageType === 40 || props.values.stageType === 50 || props.values.stageType === 60 || props.values.stageType === 70 || props.values.stageType === 80) &&
                    <div>
                        {(props.values.stageType != 60) &&
                            <Row className={styles.pipelineDetailsRow}>
                                <Col xs={12} className="mt-1 mb-1">
                                    <span className={styles.rowSubTitle}>Minimum&nbsp;Pass&nbsp;Score&nbsp;:</span>&nbsp;<span className={styles.rowValues} id="adminPanel_hiringPipeline_editPipeline_addStagesModal_review_minimumPassScoreId">{props.values.score}</span>
                                </Col>
                            </Row>
                        }
                        {(props.values.stageType != 50) &&
                            <Row className={styles.pipelineDetailsRow}>
                                <Col xs={12} className="mt-1 mb-1">
                                    <span className={styles.rowSubTitle}>Guideline&nbsp;For&nbsp;Reviewers&nbsp;:</span>&nbsp;<span className={styles.rowValues} id="adminPanel_hiringPipeline_editPipeline_addStagesModal_review_guidelineForReviewersId">{props.values.description ? props.values.description : 'No Review Criteria'}</span>
                                </Col>
                            </Row>}
                    </div>
                }

                {(props.values.stageType === 60) &&
                    <div>
                        <Row className={styles.pipelineDetailsRow}>
                            <Col xs={12} className="mt-1 mb-1">
                                <span className={styles.rowSubTitle}>Guidelines&nbsp;For&nbsp;Candidates&nbsp;:</span>&nbsp;<span className={styles.rowValues}>{props.values.guide_for_candidates ? props.values.guide_for_candidates : 'No Guideline Description'}</span>
                            </Col>
                        </Row>
                    </div>
                }

                {(props.values.stageType === 30) &&
                    <div>
                        <Row className={styles.pipelineDetailsRow}>
                            <Col xs={12} className="mt-1 mb-1">
                                <span className={styles.rowSubTitle}>Interview&nbsp;Guidelines&nbsp;For&nbsp;Candidates&nbsp;:</span>&nbsp;<span className={styles.rowValues} id="adminPanel_hiringPipeline_editPipeline_addStagesModal_review_interviewGuidelinesForCandidatesId">{props.values.interview_guidelines_to_candidate ? props.values.interview_guidelines_to_candidate : 'No Interview Guideline Description'}</span>
                            </Col>
                        </Row>
                    </div>
                }

                {(props.values.stageType === 70) &&
                    <div>
                        <Row className={styles.pipelineDetailsRow}>
                            <Col xs={12} className="mt-1 mb-1">
                                <span className={styles.rowSubTitle}>Custom Evaluation Description&nbsp;For&nbsp;Reviewers&nbsp;:</span>&nbsp;<span className={styles.rowValues} id="adminPanel_hiringPipeline_editPipeline_addStagesModal_review_customEvaluationDescriptionId">{props.values.custom_evaluation_description ? props.values.custom_evaluation_description : 'No Custom Evaluation Description'}</span>
                            </Col>
                        </Row>
                    </div>
                }

                {
                    (props.values.stageType === 10) &&
                    <div>
                        <Row className={styles.pipelineDetailsRow}>
                            <Col xs={12} className="mt-1 mb-1">
                                <span className={styles.rowSubTitle}>Keywords to Scan&nbsp;:</span><br />
                                <span className={styles.rowValues}>
                                    {props.values.keywords.map((value, index) => (
                                        <p className="mb-1" key={index} id={`adminPanel_hiringPipeline_editPipeline_addStagesModal_review_keywordToScanReviewPageId.${index}`}><i className="fas fa-circle"></i>&nbsp;{value}</p>
                                    ))
                                    }
                                </span>
                            </Col>
                        </Row>

                        <Row className={styles.pipelineDetailsRow}>
                            <Col xs={12} className="mt-1 mb-1">
                                <span className={styles.rowSubTitle}>Minimum&nbsp;Keyword&nbsp;Count&nbsp;:</span>&nbsp;<span className={styles.rowValues} id="adminPanel_hiringPipeline_editPipeline_addStagesModal_review_minimumKeywordCountReviewModeId">{props.values.keywordCount}</span>
                            </Col>
                        </Row>
                    </div>
                }

                {(props.values.stageType === 40) &&
                    <div>
                        <div>
                            <Row className={styles.assignmentPipelineDetailsRow}>
                                <Col xs={12} className="mt-1 mb-1">
                                    <span className={styles.rowSubTitle}>Assignment&nbsp;:</span>&nbsp;<span className={styles.rowValues}><div className="ql-editor" dangerouslySetInnerHTML={{ __html: props.values.assessment_body }} id="adminPanel_hiringPipeline_editPipeline_addStagesModal_review_assessmentReviewModeId"></div></span>
                                </Col>
                            </Row>
                            <Row className={styles.pipelineDetailsRow}>
                                <Col xs={12} className="mt-1 mb-1">
                                    <span className={styles.rowSubTitle}>Assignment Expire After&nbsp;:</span>&nbsp;<span className={styles.rowValues} id="adminPanel_hiringPipeline_editPipeline_addStagesModal_review_assessmentExpireAfterReviewModeId">{props.values.assessment_exp_date}</span>
                                </Col>
                            </Row>
                        </div>
                    </div>


                }

                {(props.values.stageType === 50) &&
                    <div>
                        <Row className={styles.pipelineDetailsRow}>
                            <Col xs={12} className="mt-1 mb-1">
                                <span className={styles.rowSubTitle}>Quiz Expire After&nbsp;:</span>&nbsp;<span className={styles.rowValues} id="adminPanel_hiringPipeline_editPipeline_addStagesModal_review_quizExpireAfterId">{props.values.quiz_exp_date}</span>
                            </Col>
                        </Row>
                    </div>
                }

                {(props.values.stageType === 80) &&
                    <div>
                        <Row className={styles.pipelineDetailsRow}>
                            <Col xs={12} className="mt-1 mb-1">
                                <span className={styles.rowSubTitle}>Interview Expire After&nbsp;:</span>&nbsp;<span className={styles.rowValues}>{props.values.interview_exp_in}</span>
                            </Col>
                        </Row>
                    </div>
                }
                { ( props.values.stageType === 20 || props.values.stageType === 30 || props.values.stageType === 40 ||  props.values.stageType === 70|| props.values.stageType === 80 ) &&
                    <div>
                        <Row className={styles.pipelineDetailsRow}>
                            <Col xs={12} className={styles.colWithNoSidePadding}>
                                <span className={styles.rowSubTitle}>Evaluation&nbsp;criteria&nbsp;for&nbsp;candidates&nbsp;</span>&nbsp;<br />
                                <div className='mt-2 mb-2'>
                                {((props.pipelineValues.reviewCriteria) && (props.pipelineValues.reviewCriteria).length > 0) ?
                                    (props.pipelineValues.reviewCriteria).map((values, index) => (
                                        <span className={styles.cardValues} key={index}><div className={styles.cardValuesBox}>
                                            <div className={styles.svgDiv}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <rect width="24" height="24" rx="16" fill="#D1F3FA" />
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M17.0964 7.39004L9.93638 14.3L8.03638 12.27C7.68638 11.94 7.13638 11.92 6.73638 12.2C6.34638 12.49 6.23638 13 6.47638 13.41L8.72638 17.07C8.94638 17.41 9.32638 17.62 9.75638 17.62C10.1664 17.62 10.5564 17.41 10.7764 17.07C11.1364 16.6 18.0064 8.41004 18.0064 8.41004C18.9064 7.49004 17.8164 6.68004 17.0964 7.38004V7.39004Z" fill="#32B5D3" />
                                                </svg>
                                            </div>
                                            <div className={styles.starRatingMainDiv}>
                                                <span className={styles.labelSpan} id={`adminPanel_hiringPipelines_createPipelineModal_review_reviewCriteriaReviewId.${index}`}>{values.label}</span>
                                                <span className='mt-n1'><StarRating disabled={true} id={index} /></span>
                                            </div>

                                        </div></span>
                                    ))
                                    :
                                    <span className={styles.rowValues}>No data available</span>
                                }
                                </div>
                            </Col>
                        </Row>
                    </div>
                }

                <Row className="mt-1 d-flex flex-row-reverse">
                <Col className={styles.addBtn}>
                        {<CustomButton
                            id="adminPanel_hiringPipeline_editPipeline_addStagesModal_review_addStepBtnId"
                            buttonType="submit"
                            label="Add Step"
                            type="primaryBtn"
                            disabled={state === true ? true : false}
                            backicon={
                                state === true ? (<i className="fas fa-circle-notch fa-spin"></i>)
                                    : ''
                            }
                            handleClick={() => submitDetails()}
                        />}
                    </Col>
                    <Col className={styles.actionBtns}>
                        {<CustomButton
                            id="adminPanel_hiringPipeline_editPipeline_addStagesModal_review_backBtnId"
                            buttonType="submit"
                            label="Back"
                            type="defaultBtn"
                            handleClick={() => props.previousPage(2)}

                        />}
                    </Col>
                    
                </Row>
            </Container>
        </div>
    )
}
export default Review;
